/** @jsx h */
// import { $$ } from 'src/shared/js/utils/dom';
import { labels } from '../config';
import FilterFieldset from './FilterFieldset';
import Sorting from './Sorting';

const FilterContainer = ({
  facets,
  facetsActive,
  sorting,
  triggerAjaxSubmit,
  triggerReset,
  pluginNamespace,
}) => {
  return (
    <div className="search__filter">
      {facets.map(
        (facet, index) =>
          facet.options.length > 0 && (
            <FilterFieldset
              id={index}
              key={facet.label}
              facet={facet}
              triggerAjaxSubmit={triggerAjaxSubmit}
              pluginNamespace={pluginNamespace}
            />
          )
      )}

      {sorting.length > 0 && (
        <Sorting
          sorting={sorting}
          triggerAjaxSubmit={triggerAjaxSubmit}
          pluginNamespace={pluginNamespace}
        />
      )}
      {facetsActive.selected.length > 0 && (
        <button
          className="search__filter-reset"
          onClick={triggerReset}
          type="button"
        >
          <span>{labels.faceting.removeAllFilters}</span>
          <svg
            class="svg-close"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80 80"
            aria-hidden="true"
          >
            <defs>
              <style>.cls-1 {`fill-rule: evenodd;`}</style>
            </defs>
            <polygon
              fill="currentColor"
              class="cls-1"
              points="80 5 75 0 40 35 5 0 0 5 35 40 0 75 5 80 40 45 75 80 80 75 45 40 80 5"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default FilterContainer;
